"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptDomainSchema = void 0;
const zod_1 = require("zod");
const zod_2 = require("../utils/zod");
exports.PromptDomainSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    version: zod_1.z.number(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    createdBy: zod_1.z.string(),
    isActive: zod_1.z.boolean().nullable(),
    type: zod_1.z.string().default("text"),
    tags: zod_1.z.array(zod_1.z.string()).default([]),
    labels: zod_1.z.array(zod_1.z.string()).default([]),
    prompt: zod_2.jsonSchemaNullable,
    config: zod_2.jsonSchemaNullable,
    projectId: zod_1.z.string(),
    commitMessage: zod_1.z.string().nullable(),
});
